import {useSelector} from "react-redux";
import {RootState} from "../reducers";
import {AccountType, ATLANTIC_HEALTH} from "../constants";
import {isDebug} from "../utils/commonUtils";

export const useCheckAtlantic = () =>{
    const auth: any = useSelector((state: RootState) => state.auth);
    const clientPolicy = auth && auth.user && auth.user.client && auth.user.client.clientPolicies.length > 0 && auth.user.client.clientPolicies[0];
    const role = auth && auth.user && auth.user.role;
    const companyLinkUrl = clientPolicy && clientPolicy.company && clientPolicy.company.companyLinkUrl;
    const isAtlantic = (ATLANTIC_HEALTH.includes(companyLinkUrl) && role === AccountType.Multilife);
    isDebug() && console.log({companyLinkUrl, role, isAtlantic});
    return isAtlantic;
}